import { RichUtils } from 'draft-js';
export var useContentHelpers = function (editorState, setEditorState) {
    var getCurrentlySelectedText = function () {
        var selectionState = editorState.getSelection();
        var anchorKey = selectionState.getAnchorKey();
        var currentContent = editorState.getCurrentContent();
        var currentContentBlock = currentContent.getBlockForKey(anchorKey);
        var start = selectionState.getStartOffset();
        var end = selectionState.getEndOffset();
        return currentContentBlock.getText().slice(start, end);
    };
    var getEntityTypeAtSelection = function () {
        var selectionState = editorState.getSelection();
        var selectionKey = selectionState.getStartKey();
        var contentState = editorState.getCurrentContent();
        // The block in which the selection starts
        var block = contentState.getBlockForKey(selectionKey);
        // Entity key at the start selection
        var entityKey = block.getEntityAt(selectionState.getStartOffset());
        if (entityKey) {
            // The actual entity instance
            return contentState.getEntity(entityKey).getType();
        }
        return null;
    };
    var getInlineStyleAtSelection = function () {
        return editorState.getCurrentInlineStyle();
    };
    var getBlockTypeAtSelection = function () {
        var selection = editorState.getSelection();
        return editorState.getCurrentContent().getBlockForKey(selection.getStartKey()).getType();
    };
    var toggleBlockType = function (blockType) {
        setEditorState(RichUtils.toggleBlockType(editorState, blockType));
    };
    var toggleInlineStyle = function (inlineStyle) {
        setEditorState(RichUtils.toggleInlineStyle(editorState, inlineStyle));
    };
    return {
        currentlySelectedText: getCurrentlySelectedText(),
        entityTypeAtSelection: getEntityTypeAtSelection(),
        inlineStyleAtSelection: getInlineStyleAtSelection(),
        blockTypeAtSelection: getBlockTypeAtSelection(),
        toggleBlockType: toggleBlockType,
        toggleInlineStyle: toggleInlineStyle,
    };
};
//# sourceMappingURL=useContentHelpers.js.map